import type { SVGProps } from "react";
// generated from Replay.svg — do not edit manually
// prettier-ignore
export default function Replay(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M7 7.5C8.27947 6.25156 10.0268 5.5 11.95 5.5C15.8436 5.5 19 8.61929 19 12.4667C19 16.3142 15.8436 19.4334 11.95 19.4334C8.92616 19.4334 6.34692 17.5492 5.34375 14.9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  <path d="M7 3.75V7.5H10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>);
}
